<template>
  <div class="fh-form">
    <jw-spin :loading="loading" class="fh-form-spin">
      <fh-form-content :loading="loading" ref="formContentRef" @cb="handleSubmit" :scheduleObj="scheduleObj" :modulesItem="modulesItem" :getEntityObj="getEntityObj" :followObj="followObj" :editRecord="editRecord" :buttonsObj="data.buttonsObj" :associateKey="associateKey" :findCountFieldsObj="findCountFieldsList" :type="data.type" :copy="data.copy" :viewId="data.viewId" :entity="data.entity" :id="data.id" :isAssociated="isAssociated" :form="data.form">
        <template #view>
          <div v-show="type === 30 && !grayList?.['Layout:viewInit']" class="line" />
          <select-view v-show="type === 30 && !grayList?.['Layout:viewInit']" :view-id="data.viewId" :entity="data.entity" @cb="getViewInfo" />
        </template>
      </fh-form-content>
    </jw-spin>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import SelectView from '../fh-select-view/fh-select-view.vue';
import FhFormContent from '../fh-form-content/fh-form-content.vue';
import { useRoute } from 'vue-router';
import { tools } from '@/utils/tools';
import useViewFields from '@/hooks/view-fields';
import useFormulaSetting from '@/hooks/formulaSetting';
import { cloneDeep } from 'lodash';
import { layoutService } from '@/api';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import useLoading from '@/hooks/loading';
import { useGrayscaleStore } from '@/store';
import { aiPointsRetryValidateFieldConfig } from '@/utils/const';
import { validateFhAiPointsFormData } from '@/utils/fh-ai-points.mjs';
const { getAddLayoutConfig, layoutAddModules, getEditLayoutConfig, layoutDetailModules, saveFormData, sendFormData } = useViewFields();
const { findComputeing, findCountFieldsList } = useFormulaSetting();
const { t } = useI18n();
const { loading, setLoading } = useLoading(true); //loading
const { grayList } = useGrayscaleStore();
const props = defineProps({
  id: { type: String },
  type: { required: true },
  viewId: { required: true },
  entity: { required: true },
  copy: { required: true },
  getEntityObj: { required: true },
  //2025年02月27日16:45:55 是否是关联对象表格，是的话过滤关联对象表格并且添加不走接口直接将数据组装后返回并关闭弹窗
  isAssociated: {
    type: Boolean,
    default: false
  },
  //是否从copy过来的，兼容关联对象表格复制，为落库情况下，编辑和复制所有参数一致，单独添加复制标识
  fromCopy: {
    type: Boolean,
    default: false
  },
  //关联对象表格的key 当isAssociated值为true时使用
  associateKey: {
    type: String,
    default: ''
  },
  //兼容编辑关联对象表格数据没有id的情况，直接使用数据
  editRecord: {
    type: Array,
    default: () => []
  },
  followObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  scheduleObj: {
    type: Object,
    default: () => {
      return {};
    }
  },
  fromAssociationDetail: {
    type: Boolean,
    default: false
  },
  modulesItem: {
    //查找记录的module信息
    type: Object,
    default: () => {
      return {};
    }
  }
});
const emits = defineEmits(['cb', 'cbResult']);
const route = useRoute();
const data = reactive({
  id: props.id,
  type: props.type || route.params?.type, //30: 新增 40：修改
  viewId: props.viewId || route.params?.viewId, //视图id
  entity: props.entity || route.params?.entity, //对象type
  copy: props.copy || route.params?.copy, //复制
  fromPage: route.params?.fromPage, //其他入口新增客户
  form: {
    formData: [],
    config: {}
  },
  buttonsObj: {}
});
const formContentRef = ref();
//  recordId表格的id
const formatModalData = (formData, detailModuleList, resultData = null) => {
  const _formatModalData = [];
  const { businessId = [], LOGIC_ROLE_PERMISSION = null, lockedOrigin = null } = resultData || {};
  formData?.map((fd) => {
    if (fd?.modules?.length) {
      fd?.modules?.map((fdm) => {
        if (fdm?.type == 20) {
          _formatModalData.push({
            ...cloneDeep(fdm),
            detailId: businessId?.[0] ? businessId?.[0] : !data.copy && data.id ? data.id : undefined,
            LOGIC_ROLE_PERMISSION: LOGIC_ROLE_PERMISSION || null,
            lockedOrigin: lockedOrigin || null
          });
        }
        if (fdm?.type == 35) {
          _formatModalData.push({
            ...fdm,
            detailId: businessId?.[0] ? businessId?.[0] : !data.copy && data.id ? data.id : undefined,
            LOGIC_ROLE_PERMISSION: LOGIC_ROLE_PERMISSION || null,
            lockedOrigin: lockedOrigin || null,
            modules: detailModuleList?.[fdm?.id] ? cloneDeep(detailModuleList?.[fdm?.id]) : []
          });
        }
      });
    }
  });
  //   console.log(_formatModalData, 'console.log(_formatModalData');
  emits('cbResult', _formatModalData);
};
const associatedFeildData = ref({});
const handleSubmit = async ({ type, isApprove, isSplit, formData, detailModuleList, setAssociatedFeildData = {} }) => {
  if (type === 'cancel') {
    emits('cb', 'cancel');
  } else {
    // console.log(formData, 'console.log(formData',data.type);
    associatedFeildData.value = setAssociatedFeildData;
    await formSubmit(formData, detailModuleList, isApprove, isSplit);
  }
};
const formSubmit = async (formData, detailModuleList, isApprove = false, isSplit = false) => {
  // 新建、编辑、复制统一走 AI 点数业务校验，保证表单提交与列表重试规则一致。
  const validationResult = validateFhAiPointsFormData(formData, aiPointsRetryValidateFieldConfig);

  if (!validationResult.valid) {
    Message.warning(validationResult.message);
    return false;
  }

  if (props.isAssociated && props.modulesItem?.type == 30) {
    //关联记录
    formatModalData(formData, detailModuleList);
    // emits('cb', 'submit');
    return false;
  }

  try {
    setLoading(true);
    await saveFormData(data.viewId, data.entity, formData, detailModuleList, data.type, 'addOrEdit');
    let url;
    if (isApprove) {
      //发起审批
      sendFormData.value.approve = true;
    } else {
      sendFormData.value.approve = false;
      sendFormData.value.afterApprove = true;
    }

    if (data.type == 30) {
      //新增
      if (data.entity == 10) {
        //订单拆分明细提交
        sendFormData.value.isNeedSplit = isSplit;
      }
      // 日程添加动态记录特殊参数
      if (sendFormData.value?.entity == 16 && JSON.stringify(props.scheduleObj) !== '{}') {
        sendFormData.value.data = {
          ...sendFormData.value.data,
          ...props.scheduleObj
        };
      }
      console.log('新增表单信息', sendFormData.value);
      if (associatedFeildData.value && Object.keys(associatedFeildData.value)?.length > 0) {
        //从详情的关联记录(30)新增数据时，需要把关联主键上传，给后端关联数据使用
        sendFormData.value.data = {
          ...sendFormData.value.data,
          ...associatedFeildData.value
        };
      }
      url = layoutService.add(sendFormData.value);
    } else if (data.type == 40) {
      //编辑
      url = layoutService.update(sendFormData.value);
    }

    const res = await url;
    setLoading(false);
    console.log('数据提交333', res);
    if (res.error) {
      closeLoading();
      Message.error(res.error?.msg || t('获取数据失败'));
      return;
    }

    setLoading(false);
    if (props.isAssociated && props.modulesItem?.type == 31) {
      //查询记录
      formatModalData(formData, detailModuleList, res?.result || null);
      emits('cb', 'submit');
      return false;
    }

    Message.success(t('提交成功'));
    data.form.formData = [];
    emits('cb', 'submit');
    emits('cbResult', res.result);

    return;
  } catch (e) {
    setLoading(false);
    console.log(e);
  }
};

const resolveAssociationEditViewId = ({ currentViewId, defaultViewId, fromAssociationDetail, type }) => {
  // 仅“查找关联 -> 详情 -> 编辑”时，才用默认视图覆盖接口入参。
  if (Number(type) === 40 && fromAssociationDetail && defaultViewId) {
    return Number(defaultViewId);
  }

  return currentViewId;
};

const init = async () => {
  try {
    setLoading(true);
    const layoutFn = data.type == 30 && data.copy != 1 ? getAddLayoutConfig : getEditLayoutConfig;
    const layoutParams = { viewId: data.viewId, entity: data.entity, copy: data.copy == 1 };
    if (data.type != 30 || data.copy == 1) {
      layoutParams.businessId = data.id;
    }
    await Promise.all([layoutFn(layoutParams), findComputeing(data.entity, data.viewId, data.type)]);
    const formModules = data.type == 30 && data.copy != 1 ? layoutAddModules : layoutDetailModules;

    data.form.config = formModules?.value[0] || {};
    const _formData = formModules?.value[0]?.modules?.filter((item) => item?.type != 40) || [];

    data.form.formData = _formData;
    data.buttonsObj = tools.getUpdateOptTextsByEntity(formModules?.value[0]?.modules?.filter((item) => item?.type == 40) || []);
    //初始化表单
    formContentRef.value.initForm();
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.log(e);
  }
};
//初始化获取布局，并初始化布局表单结构
const getViewInfo = (viewInfo) => {
  // SelectView 挂载后会主动回传视图信息，编辑场景也依赖这次回调决定最终 viewId。
  data.viewId = resolveAssociationEditViewId({
    currentViewId: viewInfo?.viewId,
    defaultViewId: viewInfo?.defaultView?.id,
    fromAssociationDetail: props.fromAssociationDetail,
    type: data.type
  });
  init();
};

//关闭loading
const closeLoading = () => {
  setLoading(false);
  // formContentRef.value?.setLoading?.(false);
};

defineExpose({ closeLoading });
</script>

<style scoped lang="less">
@import './fh-form.less';
</style>
